module.exports = __webpack_public_path__ + "img/gd.cffea059.jpg";